import { render, staticRenderFns } from "./openPriceTi.vue?vue&type=template&id=0afa3e26&"
import script from "./openPriceTi.vue?vue&type=script&lang=js&"
export * from "./openPriceTi.vue?vue&type=script&lang=js&"
import style0 from "./openPriceTi.vue?vue&type=style&index=0&lang=css&"
import style1 from "./openPriceTi.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports